import * as types from 'pericles-types'
import * as shared from 'pericles-shared'

export const setPresence = shared.callFunction<
  types.SetPresenceInput,
  types.DefaultResponse
>('setPresence')
